/**
 * RealCardSection
 *
 * Social proof: the actual physical card MomentSent printed and mailed during
 * the launch-day live test. Not a mockup or a render — a real card that went
 * through the real print-and-mail pipeline and arrived in a real mailbox.
 */

export default function RealCardSection() {
  return (
    <section className="bg-cream py-20">
      <div className="section-container">

        {/* Heading */}
        <div className="text-center mb-10">
          <span className="font-body text-xs font-semibold tracking-widest uppercase text-sage">
            Not a mockup
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-navy mt-3 mb-4">
            A real card. Really mailed.
          </h2>
          <p className="font-body text-sage text-lg max-w-2xl mx-auto">
            This is the actual card our system printed, stamped first‑class, and
            dropped in the mail on launch day, front and back, exactly as it
            landed in the mailbox.
          </p>
        </div>

        {/* The real card photo */}
        <div className="flex justify-center">
          <figure className="w-full max-w-3xl">
            <img
              src="/real-card.png"
              alt="The real MomentSent greeting card mailed during the launch-day live test, a black 'Happy Birthday' card front and its printed message on the back."
              loading="lazy"
              className="w-full h-auto rounded-2xl shadow-warm border border-navy/10"
            />
            <figcaption className="mt-4 text-center font-body text-sm text-sage italic">
              Live test card, mailed May 21, 2026. The system works.
            </figcaption>
          </figure>
        </div>

      </div>
    </section>
  );
}
